<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { VisSingleContainer, VisDonut } from '@unovis/vue';
import {
  Card,
  CardHeader,
  CardContent,
} from 'dashboard/components-next/ui-shadcn/card';

const props = defineProps({
  online: { type: Number, default: 0 },
  busy: { type: Number, default: 0 },
  offline: { type: Number, default: 0 },
});

const { t } = useI18n();

const segments = computed(() => [
  {
    label: t('PAINEL_PRINCIPAL.AGENT_STATUS.ONLINE'),
    value: props.online,
    color: '#22C55E',
  },
  {
    label: t('PAINEL_PRINCIPAL.AGENT_STATUS.BUSY'),
    value: props.busy,
    color: '#FACC15',
  },
  {
    label: t('PAINEL_PRINCIPAL.AGENT_STATUS.OFFLINE'),
    value: props.offline,
    color: '#94A3B8',
  },
]);

const total = computed(() => props.online + props.busy + props.offline);

const value = d => d.value;
const colorFn = (_, i) => segments.value[i]?.color || '#1F61F4';
</script>

<template>
  <Card>
    <CardHeader>
      <h3 class="text-base font-semibold text-n-slate-12">
        {{ t('PAINEL_PRINCIPAL.AGENT_STATUS.TITLE') }}
      </h3>
      <span
        class="size-7 rounded-md bg-n-alpha-2 flex items-center justify-center text-n-slate-11"
      >
        <span class="i-lucide-users size-4" />
      </span>
    </CardHeader>
    <CardContent class="pt-0">
      <div class="relative h-44 mb-4">
        <VisSingleContainer :data="segments" :height="176">
          <VisDonut
            :value="value"
            :color="colorFn"
            :arc-width="22"
            :pad-angle="0.02"
            :corner-radius="4"
            central-label=""
          />
        </VisSingleContainer>
        <div
          class="absolute inset-0 flex flex-col items-center justify-center pointer-events-none"
        >
          <span class="text-3xl font-bold text-n-slate-12">{{ total }}</span>
          <span class="text-xs text-n-slate-10">
            {{ t('PAINEL_PRINCIPAL.AGENT_STATUS.TOTAL') }}
          </span>
        </div>
      </div>
      <ul class="grid grid-cols-3 gap-2 text-xs">
        <li
          v-for="seg in segments"
          :key="seg.label"
          class="flex items-center gap-1.5 min-w-0"
        >
          <span
            class="size-2.5 rounded-sm shrink-0"
            :style="{ background: seg.color }"
          />
          <span class="text-n-slate-11 truncate">{{ seg.label }}</span>
          <span class="text-n-slate-12 font-semibold ml-auto">
            {{ seg.value }}
          </span>
        </li>
      </ul>
    </CardContent>
  </Card>
</template>
